import React, { Component } from 'react';
import styled from 'styled-components/macro';
import { connect } from 'react-redux';
import { rgba } from 'polished';
import {
  fetchProgPlus,
  resetProg,
  resetProgResume,
  fetchAddToList,
  fetchProgResumePlus,
  resetProgPlus,
  channelsFetchData,
} from '../actions';
import translate from './TranslateHOC';
import {
  programmeTitle,
  isGenreMatch,
  iOS,
  getSignedPref,
  setSignedPref,
  getSelectedChannel,
} from '../helpers';
import {
  getPlayerTextTracks,
  setSubtitleId,
  getSubtitleId,
} from '../player_helpers';
import CardGrid from './CardGrid';
import ProgrammePlayerController from './ProgrammePlayerController';
import PageMeta from './PageMeta';
import Helmet from 'react-helmet';
import IsLoadingAnim from './alerts/IsLoadingAnim';
import {
  PAGE_TITLE_SEPARATOR,
  BASE_URL,
  CYW_ID,
  SIGNED_URL_STRING,
  SUBTITLE_ID_NONE,
  SUBTITLE_ID_CY,
  SUBTITLE_ID_EN,
  EN_FORM_VALUE,
  CY_FORM_VALUE,
  MORE_LIKE_NUM_RESULTS,
  localStorageIsChild,
} from '../constants';
import ProgrammeIconLink from './ProgrammeIconLink';
import { parse } from 'query-string';

class Programme extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isToggle: false,
      playNow: false,
      subtitleId: getSubtitleId(),
      isPlaying: false,
      iosSubtitleId: false,
      signedId: getSignedPref(),
    };
    this.handleClick = this.handleClick.bind(this);
    this.updateSubtitleId = this.updateSubtitleId.bind(this);
    this.handleSubtitlesLoaded = this.handleSubtitlesLoaded.bind(this);
    this.handlePlayerSubtitlesChange =
      this.handlePlayerSubtitlesChange.bind(this);
    this.resetIsPlaying = this.resetIsPlaying.bind(this);
    this.toggleSigned = this.toggleSigned.bind(this);
  }

  componentWillUnmount = () => {
    this.props.resetProg();
    this.props.resetProgResume();
    this.props.resetProgPlus();
    this.resetIsPlaying();
  };

  componentDidMount = () => {
    this.checkUrlSigned();
    this.props.fetchChannels();

    if (this.props.match.params.series_id) {
      this.props.fetchProgPlus(
        this.props.match.params.series_id,
        true,
        MORE_LIKE_NUM_RESULTS
      );
    } else {
      this.props.fetchProgPlus(
        this.props.match.params.id,
        false,
        MORE_LIKE_NUM_RESULTS
      );
    }
    window.scrollTo(0, 0);
  };

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    // On prog, series or lang change then re load
    if (
      (nextProps.match.params.id &&
        nextProps.match.params.id !== this.props.match.params.id) ||
      (nextProps.match.params.series_id &&
        nextProps.match.params.series_id !==
          this.props.match.params.series_id) ||
      nextProps.curLang !== this.props.curLang
    ) {
      this.props.fetchChannels();
      this.resetIsPlaying();
      this.props.resetProg();
      this.props.resetProgResume();
      this.props.resetProgPlus();
      if (nextProps.match.params.series_id) {
        this.props.fetchProgPlus(
          nextProps.match.params.series_id,
          true,
          MORE_LIKE_NUM_RESULTS
        );
      } else {
        this.props.fetchProgPlus(
          nextProps.match.params.id,
          false,
          MORE_LIKE_NUM_RESULTS
        );
      }
      if (
        (nextProps.match.params.id &&
          nextProps.match.params.id !== this.props.match.params.id) ||
        (nextProps.match.params.series_id &&
          nextProps.match.params.series_id !==
            this.props.match.params.series_id)
      ) {
        window.scrollTo(0, 0);
      }
    }
    // on a profile change
    if (this.props.profileName !== nextProps.profileName) {
      this.resetIsPlaying();
      if (nextProps.prog.full_prog_details) {
        this.props.resetProgPlus();
        this.props.fetchProgResumePlus(
          nextProps.prog.full_prog_details.id,
          nextProps.prog.full_prog_details.series_id,
          MORE_LIKE_NUM_RESULTS,
          nextProps.prog.full_prog_details.genre_ids
        ); // will have no effect if video already playing
      }
    }
    // If lang change ot add remove action then re-pull the add to list
    if (this.props.curLang !== nextProps.curLang) {
      this.props.fetchAddToList();
    }

    if (
      !this.props.prog.full_prog_details &&
      nextProps.prog.full_prog_details &&
      this.props.match.params.signed &&
      !nextProps.prog.full_prog_details.other_version_available &&
      (this.props.match.params.signed === SIGNED_URL_STRING ||
        this.props.match.params.signed === '1')
    ) {
      const regex = new RegExp(SIGNED_URL_STRING + '|1', 'g');
      const res = this.props.location.pathname.replace(regex, '');
      this.props.history.push(
        res.replace(/\/+$/, '') + this.props.location.search
      );
    }
  };

  handleClick(e) {
    this.setState({
      isToggle: !this.state.isToggle,
    });
  }

  /* All the Subtitles Functions here please */
  updateSubtitleId = (e, type = SUBTITLE_ID_NONE, updatePlayer = false) => {
    // Update subtitle Id
    if (updatePlayer) {
      // Only update the player subtitles if from ProgrammeDetails
      const tracks = getPlayerTextTracks();
      if (tracks.length > 0) {
        let track;
        for (var i = 0; i < tracks.length; i++) {
          track = tracks[i];
          if (track['language'] && track['language'] === CY_FORM_VALUE) {
            // Update the Welsh
            if (
              type === 1 &&
              parseInt(this.state.subtitleId, 10) !== SUBTITLE_ID_CY
            ) {
              track.mode = 'showing';
            } else {
              track.mode = 'disabled';
            }
          }

          if (track['language'] && track['language'] === EN_FORM_VALUE) {
            // Update the English
            if (
              type === 2 &&
              parseInt(this.state.subtitleId, 10) !== SUBTITLE_ID_EN
            ) {
              track.mode = 'showing';
            } else {
              track.mode = 'disabled';
            }
          }
        }
      }
    }
    /* Update the Subtitle Selction 0 = None, 1 = Welsh, 2 = English */
    const update = !updatePlayer
      ? type
      : parseInt(this.state.subtitleId, 10) === type
      ? SUBTITLE_ID_NONE
      : type;
    this.setState({ subtitleId: update });
    setSubtitleId(update);
  };

  handlePlayerSubtitlesChange = (event) => {
    /* Handle the player side of the subtitles */
    if (this.state.isPlaying) {
      const tracks = getPlayerTextTracks();
      if (tracks.length > 0) {
        let subtitleOptions = SUBTITLE_ID_NONE,
          track;
        for (var i = 0; i < tracks.length; i++) {
          track = tracks[i];
          if (track['language'] && track['language'] === CY_FORM_VALUE) {
            if (track['mode'] === 'showing') {
              subtitleOptions = SUBTITLE_ID_CY;
            } else {
              // This is for the bad browsers onload workaround
              if (
                iOS() &&
                this.state.iosSubtitleId &&
                parseInt(this.state.iosSubtitleId, 10) === 1
              ) {
                track.mode = 'showing';
                this.setState({ iosSubtitleId: false });
                subtitleOptions = SUBTITLE_ID_CY;
              }
            }
          }
          if (track['language'] && track['language'] === EN_FORM_VALUE) {
            if (track['mode'] === 'showing') {
              subtitleOptions = SUBTITLE_ID_EN;
            } else {
              // This is for the bad browsers onload workaround
              if (
                iOS() &&
                this.state.iosSubtitleId &&
                parseInt(this.state.iosSubtitleId, 10) === 2
              ) {
                track.mode = 'showing';
                this.setState({ iosSubtitleId: false });
                subtitleOptions = SUBTITLE_ID_EN;
              }
            }
          }
        }

        this.updateSubtitleId(event, subtitleOptions);
      }
    }
  };

  handleSubtitlesLoaded = () => {
    /* Handle the subtitle options onplayer load */
    if (!this.state.isPlaying) {
      // Set the player subtitle options before video plays
      const tracks = getPlayerTextTracks();
      if (tracks.length > 0) {
        let track;
        for (var i = 0; i < tracks.length; i++) {
          track = tracks[i];
          if (
            track['language'] &&
            track['language'] === CY_FORM_VALUE &&
            parseInt(this.state.subtitleId, 10) === SUBTITLE_ID_CY
          ) {
            track.mode = 'showing';
          }
          if (
            track['language'] &&
            track['language'] === EN_FORM_VALUE &&
            parseInt(this.state.subtitleId, 10) === SUBTITLE_ID_EN
          ) {
            track.mode = 'showing';
          }
        }
      }
    }

    this.setState({
      iosSubtitleId: parseInt(this.state.subtitleId, 10),
    });
    this.setState({ isPlaying: true });
  };

  resetIsPlaying() {
    this.setState({ isPlaying: false });
  }

  toggleSigned = () => {
    setSignedPref(parseInt(this.state.signedId, 10) === 0 ? 1 : 0);
    if (
      this.props.match.params.signed &&
      (this.props.match.params.signed === SIGNED_URL_STRING ||
        this.props.match.params.signed === '1')
    ) {
      let id = this.props.prog.full_prog_details.id;
      let progLink = `/programme/${id}`;
      this.props.history.push(progLink);
    } else {
      this.props.history.go(0);
    }
    //this.setState ({ signedId: parseInt(this.state.signedId, 10) === 0 ? 1 : 0 });
  };

  checkUrlSigned = () => {
    //If from signed category force signed to be on
    if (
      this.props.match.params.signed &&
      (this.props.match.params.signed === SIGNED_URL_STRING ||
        this.props.match.params.signed === '1')
    ) {
      setSignedPref(1);
      this.setState({ signedId: 1 });
    }
  };

  render() {
    const {
      curLang,
      strings,
      prog,
      progIsLoading,
      progHasErrored,
      stingSeriesIdItems,
      stingProgrammeIdItems,
      stingCatIdItems,
      advertsDisableItems,
      advertsHasErrored,
      progResume,
      progResumeHasErrored,
      myList,
      auth,
      isProgPlusComplete,
      channels,
      moreLike,
      moreLikeHasErrored,
      moreLikeIsLoading,
    } = this.props;
    const { full_prog_details, other_progs_in_series, other_progs_in_genres } =
      this.props.prog;
    let isCyw,
      programmeClass = 'programme-holder main',
      selectedChannel = {};

    let hideMoreLike = false;

    if (full_prog_details) {
      isCyw = isGenreMatch(full_prog_details.genre_ids, CYW_ID);
      selectedChannel = getSelectedChannel(
        full_prog_details.genre_ids,
        channels
      );
      if (
        selectedChannel &&
        Object.keys(selectedChannel).length > 0 &&
        selectedChannel.cssClass &&
        selectedChannel.cssClass.length > 0
      ) {
        programmeClass += ` programme-holder`;
      }
    }

    if (localStorage.getItem(localStorageIsChild)) {
      hideMoreLike =
        localStorage.getItem(localStorageIsChild) === 'N'
          ? false
          : !isCyw
          ? true
          : false;
    }

    if (progHasErrored || advertsHasErrored || progResumeHasErrored) {
      return (
        <div className={programmeClass}>
          <div className="alert alert--error">{strings.sorryLoading}</div>
        </div>
      );
    }

    if (progIsLoading || Object.keys(prog).length <= 0 || !isProgPlusComplete) {
      return (
        <div className="programme__player-loading">
          <IsLoadingAnim />
        </div>
      );
    }
    const progTitles = programmeTitle(
      full_prog_details.series_title,
      full_prog_details.programme_title,
      full_prog_details.clic_aired
    );

    // if the user is unAuth and comp login is true, then disablePlayBack (passed as props to <ProgrammePlayerController>)
    const disablePlayBack = !auth ? true : false;

    /* Get recommendationId from URL and pass it on */
    const recommendationId = parse(this.props.location.search).recommendationId;
    const showMyS4CMoreLike =
      auth &&
      moreLike &&
      Object.keys(moreLike).length > 0 &&
      !moreLikeHasErrored
        ? true
        : false;

    return (
      <div className={programmeClass}>
        <PageMeta
          title={`${progTitles.title} ${PAGE_TITLE_SEPARATOR} ${progTitles.subTitle}`}
          description={full_prog_details.short_billing}
          data={{
            section: 'programme',
            prog,
          }}
        />
        <Helmet>
          <meta property="og:site_name" content="S4C" />
          <meta property="og:type" content="article" />
          <meta property="og:title" content={progTitles.title} />

          <meta
            property="og:url"
            content={`https://www.s4c.cymru/clic/programme/${full_prog_details.id}`}
          />
          <meta
            property="og:description"
            content={full_prog_details.short_billing}
          />
          <meta
            property="og:image"
            content={`${BASE_URL}amg/1920x1080/${full_prog_details.thumbnail_url}`}
          />

          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:site" content="@s4c" />
          <meta name="twitter:title" content={progTitles.title} />
          <meta
            name="twitter:url"
            content={`https://www.s4c.cymru/clic/programme/${full_prog_details.id}`}
          />
          <meta
            name="twitter:image"
            content={`${BASE_URL}amg/1920x1080/${full_prog_details.thumbnail_url}`}
          />
          <meta
            name="twitter:description"
            content={full_prog_details.short_billing}
          />
        </Helmet>
        <ProgrammeIconLink channel={selectedChannel} strings={strings} />
        {Object.keys(prog).length > 0 &&
          Object.keys(stingSeriesIdItems).length > 0 && (
            <div>
              <div
                className={
                  isCyw
                    ? 'programme-holder-inner programme-holder-inner--boxset background-strip'
                    : 'programme-holder-inner background-strip'
                }
              >
                <ProgrammePlayerController
                  prog={full_prog_details}
                  progResume={progResume}
                  curLang={curLang}
                  seriesProgs={other_progs_in_series}
                  moreProgs={other_progs_in_genres}
                  stingSeries={stingSeriesIdItems}
                  stingProgramme={stingProgrammeIdItems}
                  stingCat={stingCatIdItems}
                  advertsDisable={advertsDisableItems}
                  history={this.props.history}
                  location={this.props.location}
                  myList={myList}
                  disablePlayBack={disablePlayBack}
                  loginRedirect={
                    !auth &&
                    this.props.location.pathname &&
                    this.props.location.pathname !== '/'
                      ? this.props.location.pathname
                      : ''
                  }
                  updateSubtitleId={this.updateSubtitleId}
                  subtitleId={parseInt(this.state.subtitleId, 10)}
                  handleSubtitlesLoaded={this.handleSubtitlesLoaded}
                  handlePlayerSubtitlesChange={this.handlePlayerSubtitlesChange}
                  resetIsPlaying={this.resetIsPlaying}
                  signed={
                    full_prog_details.other_version_available &&
                    parseInt(this.state.signedId, 10) === 1
                      ? 1
                      : 0
                  }
                  toggleSigned={this.toggleSigned}
                  recommendationId={recommendationId}
                  moreLike={moreLike}
                />
              </div>
              {(Object.keys(other_progs_in_series).length > 0 ||
                Object.keys(other_progs_in_genres).length > 0 ||
                Object.keys(moreLike).length > 0) && (
                <div className="programme__others">
                  {Object.keys(other_progs_in_series).length > 0 && (
                    <CardGridContainer>
                      <h2 className="section-title">
                        {strings.allEpisodesOf} {progTitles.title}
                      </h2>
                      {progIsLoading && <IsLoadingAnim />}
                      <CardGrid
                        gridType="programme"
                        items={other_progs_in_series}
                        itemSelectedId={full_prog_details.id}
                      />
                    </CardGridContainer>
                  )}
                  {!hideMoreLike &&
                    !showMyS4CMoreLike &&
                    Object.keys(other_progs_in_genres).length > 0 && (
                      <CardGridContainer>
                        <h2 className="section-title">
                          {strings.moreLike} {progTitles.title}
                        </h2>
                        {progIsLoading && <IsLoadingAnim />}
                        <CardGrid
                          gridType="programme"
                          items={other_progs_in_genres}
                        />
                      </CardGridContainer>
                    )}

                  {!hideMoreLike &&
                    showMyS4CMoreLike &&
                    Object.keys(moreLike).length > 0 && (
                      <CardGridContainer>
                        <h2 className="section-title">
                          {strings.moreLike} {progTitles.title}
                        </h2>
                        {moreLikeIsLoading && <IsLoadingAnim />}
                        <CardGrid gridType="programme" items={moreLike} />
                      </CardGridContainer>
                    )}
                </div>
              )}
            </div>
          )}{' '}
      </div>
    );
  }
}

const CardGridContainer = styled.section`
  clear: both;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  z-index: 10;
  & + & {
    box-shadow: inset 0 1px 0 0
      ${(props) =>
        props.theme.name === 'light'
          ? rgba(props.theme.color.blackFull, 0.25)
          : props.theme.color.white10};
  }
`;

const mapStateToProps = (state) => {
  return {
    curLang: state.curLang,
    prog: state.prog.success,
    progIsLoading: state.prog.loading,
    progHasErrored: state.prog.error,
    advertsIsLoading: state.advertsIsLoading,
    advertsHasErrored: state.advertsHasErrored,
    stingSeriesIdItems: state.stingSeriesIdItems,
    stingProgrammeIdItems: state.stingProgrammeIdItems,
    stingCatIdItems: state.stingCatIdItems,
    advertsDisableItems: state.advertsDisableItems,
    progResume: state.progResumeFetch,
    progResumeIsLoading: state.progResumeIsLoading,
    progResumeHasErrored: state.progResumeHasErrored,
    profileName: state.profileName,
    myList: state.list.success,
    auth: state.auth.authenticated,
    isProgPlusComplete: state.progPlus.success,
    channels: state.channels.success,
    moreLike: state.moreLike.success,
    moreLikeIsLoading: state.moreLike.loading,
    moreLikeHasErrored: state.moreLike.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    resetProg: () => dispatch(resetProg()),
    resetProgPlus: () => dispatch(resetProgPlus()),
    resetProgResume: () => dispatch(resetProgResume()),
    fetchProgPlus: (id, isSeries = false, num_results) =>
      dispatch(fetchProgPlus(id, isSeries, num_results)),
    fetchAddToList: () => dispatch(fetchAddToList()),
    fetchProgResumePlus: (id, series_id, num_results, genre_ids) =>
      dispatch(fetchProgResumePlus(id, series_id, num_results, genre_ids)),
    fetchChannels: () => dispatch(channelsFetchData()),
  };
};

export default translate(
  connect(mapStateToProps, mapDispatchToProps)(Programme)
);
